import React from "react";
import { useDispatch } from "react-redux";
import Measure from "react-measure";
import {
	DataGrid,
	ProgressIndicator
} from "rhombus-react";

import { Assets } from "reducers/Assets";

import { ASSET_COLUMNS } from "widgets/grid/columns/Assets";
import {
	MIN_GRID_HEIGHT
	, DEFAULT_ROW_HEIGHT
} from "utils/constants";

import { buildAssetId } from "utils/Assets";
import { useGridScrollUtils } from "utils/DataGrid";
import SelectedRow from "utils/columns/SelectedRow";

import { AssetSocketListener } from "hooks/useAssetSocket";
import { useTooltipRebuild } from "hooks/useTooltipRebuild";

export default function Grid({
	assets,
	sort,
	libraryId,
	isLoading,
	columns,
	resetScroll, // If true, we reset the scroll position when the assets change.
}){
	const resetScrollDependencies = resetScroll ? [assets] : [];
	const dataGridRef = useGridScrollUtils(resetScrollDependencies)
		, dispatch = useDispatch()
		, [sortColumn, sortDirection] = sort.split(":")
		;
	useTooltipRebuild(assets);

	function getAssetRow(rowID){
		if(rowID === -1){ return; } // -1 is the header row, and doesn't need to return data
		const row = assets[rowID];
		return { ...row, assetId: buildAssetId(row) };
	}

	function onRowClick(rowIdx, row, col) {
		if(rowIdx === -1){ return; }  // Ignore clicks on the header row

		if (col.onClick && !row.isDisabled) {
			col.onClick(row);
		}
	}

	const dataGridProps = {
		columns,
		rowGetter:  getAssetRow,
		rowsCount:  assets.length,
		rowHeight:  DEFAULT_ROW_HEIGHT,
		rowRenderer: SelectedRow,
		sortColumn,
		sortDirection,
		onGridSort: (col, dir) => dispatch(Assets.setSort(col, dir)),
		enableCellAutoFocus: false, /*
			This is a ReactDataGrid setting that defaults to `true`, which seems to make it fight
			with anything else trying to utilize regular `tabindex` control flow, like blade forms.
		*/
		onRowClick,
	};

	return (
		<AssetSocketListener>
			<Measure>
				{(obj) => {
					let gridHeight = obj?.contentRect?.entry?.height || MIN_GRID_HEIGHT;

					return (
						<div className="measure-component" ref={obj.measureRef}>
							<ProgressIndicator isLoading={isLoading} />
							<div ref={dataGridRef}>
								<DataGrid
									{...dataGridProps}
									minHeight={gridHeight}
								/>
							</div>
						</div>
					);
				}}
			</Measure>
		</AssetSocketListener>
	);
}

Grid.displayName = "AssetGrid";
Grid.defaultProps = {
	assets: [],
	sort: "",
	libraryId: -1,
	isLoading: false,
	columns: ASSET_COLUMNS,
	resetScroll: false,
};
